export const CHAT_MESSAGES_ENDPOINT = '/c/v2/chat/messages';
export const CHAT_ASSISTANT_MESSAGES_ENDPOINT = '/c/v2/chat/assistant/messages';
export const GET_CHAT_MESSAGE_ATTACHMENTS_ENDPOINT =
  '/c/v1/chat/messages/:messageId/attachments';
export const GET_HISTORICAL_CHAT_MESSAGE_ENDPOINT =
  '/c/v2.1/chat/sessions/:conversationId/messages&count=:count&before=:before';
